import { render } from "./RolePermissionTab.vue?vue&type=template&id=78c2bf08&scoped=true"
import script from "./RolePermissionTab.vue?vue&type=script&lang=js"
export * from "./RolePermissionTab.vue?vue&type=script&lang=js"

import "./RolePermissionTab.vue?vue&type=style&index=0&id=78c2bf08&lang=scss&scoped=true"
import "./RolePermissionTab.vue?vue&type=style&index=1&id=78c2bf08&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c2bf08"]])

export default __exports__